import Vue from 'vue'
const constants = require('@/util/constants')
// import * as constants from '@/util/constants'

/**
 * 类别
 */
export const categories = state => {
    return state.categories
}

export const currentCategory = state => {
    return state.current_category
}

export const articles = state => {
    return state.articles
}

export const currentArticle = state => {
    return state.current_article
}

export const knowledgebase = state => {
    return state.knowledgebase
}